import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Modal } from "../../ui";
import CodeEntry from "./CodeEntry";

// How people actually get a game code today: from the app's "play on the
// website", or not at all when the game is started from the website.
export const GameCodeHelp = () => (
  <ol className="space-y-3 text-sm text-white/75 leading-relaxed">
    <li className="flex gap-3">
      <span className="w-6 h-6 shrink-0 rounded-full bg-mainButton text-white text-xs font-bold flex items-center justify-center">
        1
      </span>
      <span>
        <b className="text-white">من التطبيق:</b> افتح لعبتك واضغط «إبدأ لعبة
        بالموقع»، يطلع لك كود من 6 خانات. اكتبه هنا من التلفزيون أو اللابتوب.
      </span>
    </li>
    <li className="flex gap-3">
      <span className="w-6 h-6 shrink-0 rounded-full bg-mainButton text-white text-xs font-bold flex items-center justify-center">
        2
      </span>
      <span>
        <b className="text-white">من الموقع:</b> سجّل دخولك، افتح «ألعابي» واختر
        اللعبة ثم «ابدأ اللعب». ما تحتاج تكتب أي كود.
      </span>
    </li>
  </ol>
);

const CodeEntryModal = ({ open, onClose }) => {
  const [helpOpen, setHelpOpen] = useState(false);
  return (
    <Modal open={open} onClose={onClose} title="عندك كود؟">
      <p className="text-white/70 text-sm mb-4">
        اكتب كود اللعبة أو كود الخصم، ونوديك للمكان الصحيح.
      </p>
      <CodeEntry onDone={onClose} autoFocus />
      <div className="mt-5 border-t border-white/10 pt-4">
        <button
          type="button"
          onClick={() => setHelpOpen((v) => !v)}
          aria-expanded={helpOpen}
          className="w-full flex items-center justify-between text-sm font-bold text-white/85 hover:text-white"
        >
          كيف أحصل على كود اللعبة؟
          <FaChevronDown
            className={`text-xs transition-transform ${helpOpen ? "rotate-180" : ""}`}
          />
        </button>
        {helpOpen && (
          <div className="mt-3">
            <GameCodeHelp />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CodeEntryModal;
